export default {
  'pages.layouts.userLayout.title': 'こんにちは！',
  'pages.getCaptchaSecondText': '秒',
  'pages.workbench.link': 'ようこそ',
  'pages.workbench.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',
  'pages.template.title': 'テンプレート',
  'pages.template.submit.success': 'フォームを送信しました！',
  'pages.template.form.name': '氏名',
  'pages.template.form.email': 'メール',
  'pages.template.form.department': '部署',
  'pages.template.form.joinDate': '入社日',
  'pages.template.form.remarks': '備考',
  'pages.template.placeholder.name': '氏名を入力してください',
  'pages.template.placeholder.email': 'メールを入力してください',
  'pages.template.placeholder.department': '部署を選択してください',
  'pages.template.placeholder.remarks': '備考を入力してください',
  'pages.template.validation.nameRequired': '氏名を入力してください',
  'pages.template.validation.emailRequired': 'メールを入力してください',
  'pages.template.validation.emailInvalid': 'メール形式が正しくありません',
  'pages.template.validation.departmentRequired': '部署を選択してください',
  'pages.template.validation.joinDateRequired': '入社日を選択してください',
  'pages.template.department.tech': '技術部',
  'pages.template.department.sales': '営業部',
  'pages.template.department.hr': '人事部',
  'pages.template.department.finance': '財務部',
  'pages.template.action.submit': '送信',
  'pages.template.action.reset': 'リセット',

  // プロジェクト管理
  'pages.projects.column.name': 'プロジェクト名',
  'pages.projects.column.description': '説明',
  'pages.projects.column.appCount': 'アプリ数',
  'pages.projects.column.memberCount': 'メンバー数',
  'pages.projects.column.createdAt': '作成日時',
  'pages.projects.column.action': 'アクション',
  'pages.projects.action.detail': '詳細',
  'pages.projects.action.cancel': 'キャンセル',
  'pages.projects.action.save': '保存',
  'pages.projects.action.delete': '削除',
  'pages.projects.action.remove': '削除',
  'pages.projects.form.name': 'プロジェクト名',
  'pages.projects.form.name.placeholder': 'プロジェクト名を入力してください',
  'pages.projects.form.description': '説明と業務目標',
  'pages.projects.form.description.placeholder':
    'このプロジェクトで運用するマイクロサービスやチームの責務を記述...',
  'pages.projects.create.title': 'プロジェクト作成',
  'pages.projects.create.success': 'プロジェクトを作成しました',
  'pages.projects.tab.overview': '概要',
  'pages.projects.tab.market': 'マーケット',
  'pages.projects.tab.apps': 'アプリ',
  'pages.projects.tab.databases': 'データベース',
  'pages.projects.tab.storage': 'ストレージ',
  'pages.projects.tab.members': 'メンバー',
  'pages.projects.tab.auditLog': '監査ログ',
  'pages.projects.tab.settings': '設定',

  // 概要
  'pages.projects.overview.healthDistribution': 'アプリ健全性分布',
  'pages.projects.overview.resourceQuota': 'リソースクォータ使用状況',
  'pages.projects.overview.resourceUsage': 'リソース使用状況ボード',
  'pages.projects.overview.field.runningApps': '稼働中アプリ',
  'pages.projects.overview.cpuUsed': 'CPU クォータ',
  'pages.projects.overview.memoryUsed': 'メモリクォータ',
  'pages.projects.overview.storageUsed': 'ストレージ',
  'pages.projects.overview.quickEntry': 'クイックアクション',
  'pages.projects.overview.quickEntry.appList': 'アプリ一覧',
  'pages.projects.overview.quickEntry.market': 'テンプレートからインストール',
  'pages.projects.overview.quickEntry.inviteMember': 'メンバー招待',
  'pages.projects.overview.serviceHealthRate': 'サービス健全率',
  'pages.projects.overview.cpuQuota': 'CPU クォータ',
  'pages.projects.overview.recentActivity': '最近のアクティビティ',
  'pages.projects.overview.noActivity': '最近の操作記録はありません',

  // マーケット
  'pages.projects.market.title': 'アプリ＆ミドルウェアマーケット',
  'pages.projects.market.subtitle':
    'ファーストパーティスイートと標準ミドルウェア',
  'pages.projects.market.category.all': 'すべてのテンプレート',
  'pages.projects.market.category.workvista': 'WorkVista 公式スイート',
  'pages.projects.market.category.middleware': 'データ＆ミドルウェア',
  'pages.projects.market.installAction': 'プロジェクトにインストール',
  'pages.projects.market.installModalTitle':
    'アプリテンプレートのインストール: {name}',
  'pages.projects.market.installSuccess':
    'テンプレートのデプロイが完了しました',

  // データベース
  'pages.projects.databases.title': 'データベース＆ストレージインスタンス',
  'pages.projects.databases.create': 'DB インスタンス作成',
  'pages.projects.databases.column.name': 'インスタンス名',
  'pages.projects.databases.column.engine': 'エンジンとバージョン',
  'pages.projects.databases.column.status': 'ステータス',
  'pages.projects.databases.column.host': '接続エンドポイント',
  'pages.projects.databases.column.storage': 'ストレージ使用率',
  'pages.projects.databases.connString': '接続文字列',
  'pages.projects.databases.action.restart': '再起動',
  'pages.projects.databases.action.stop': '停止',
  'pages.projects.databases.createSuccess':
    'データベースインスタンスを作成しました',
  'pages.projects.databases.actionSuccess': 'データベース操作を発行しました',

  // ストレージ
  'pages.projects.storage.title': 'オブジェクトストレージ (S3 互換)',
  'pages.projects.storage.create': 'バケット作成',
  'pages.projects.storage.column.bucket': 'バケット名',
  'pages.projects.storage.column.endpoint': 'S3 エンドポイント',
  'pages.projects.storage.column.quota': '使用量 / クォータ',
  'pages.projects.storage.column.files': 'オブジェクト数',
  'pages.projects.storage.column.acl': 'アクセス制御',
  'pages.projects.storage.column.keys': 'アクセスキー (AK/SK)',
  'pages.projects.storage.createSuccess': 'バケットを作成しました',
  'pages.projects.storage.fileList': 'ファイル一覧',

  // アプリ
  'pages.projects.app.column.status': 'ステータス',
  'pages.projects.app.column.category': 'タイプ',
  'pages.projects.app.column.repoUrl': 'リポジトリ',
  'pages.projects.app.column.version': 'バージョン',
  'pages.projects.app.column.endpoints': 'アクセスURL',
  'pages.projects.app.create.title': 'アプリ作成',
  'pages.projects.app.create.success': 'アプリを作成しました',
  'pages.projects.app.form.name.placeholder': 'アプリ名を入力してください',
  'pages.projects.app.form.category': 'アプリタイプ',
  'pages.projects.app.form.repoMode': 'リポジトリソース',
  'pages.projects.app.form.repoMode.create': 'リポジトリ自動作成',
  'pages.projects.app.form.repoMode.bind': '既存リポジトリを連携',
  'pages.projects.app.form.repoMode.create.hint':
    'Coral アプリ標準に沿って自動作成されます。URL入力は不要です',
  'pages.projects.app.form.repoUrl': 'リポジトリURL',
  'pages.projects.app.form.repoUrl.invalid':
    '有効な Git URL を入力してください',
  'pages.projects.app.overview': 'アプリ概要',
  'pages.projects.appStatus.draft': '未デプロイ',
  'pages.projects.appStatus.deploying': 'デプロイ中',
  'pages.projects.appStatus.running': '稼働中',
  'pages.projects.appStatus.stopped': '停止中',
  'pages.projects.appStatus.failed': 'エラー',

  // アプリ詳細 Tab
  'pages.projects.app.tab.overview': '概要とトポロジー',
  'pages.projects.app.tab.logs': 'リアルタイムログ',
  'pages.projects.app.tab.deploy': 'デプロイ設定',
  'pages.projects.app.tab.history': 'リリース履歴＆ロールバック',
  'pages.projects.app.pod.title': 'Pod インスタンス健全性とリソース',
  'pages.projects.app.pod.name': 'Pod 名',
  'pages.projects.app.pod.node': '実行ノード',
  'pages.projects.app.pod.ip': 'Pod IP',
  'pages.projects.app.pod.restarts': '再起動回数',
  'pages.projects.app.pod.cpu': 'CPU 使用量',
  'pages.projects.app.pod.memory': 'メモリ使用量',
  'pages.projects.app.logs.autoScroll': '自動スクロール',
  'pages.projects.app.logs.clear': 'クリア',
  'pages.projects.app.logs.download': 'ログダウンロード',
  'pages.projects.app.logs.search': 'ログキーワード検索...',
  'pages.projects.app.history.version': 'バージョン',
  'pages.projects.app.history.commit': 'Git コミット',
  'pages.projects.app.history.operator': 'デプロイ担当者',
  'pages.projects.app.history.time': 'デプロイ日時',
  'pages.projects.app.history.rollback': 'このバージョンへロールバック',
  'pages.projects.app.history.rollbackConfirm':
    'バージョン {version} にロールバックしますか？',
  'pages.projects.app.history.rollbackSuccess': 'ロールバックを実行しました',

  'pages.projects.app.column.branch': 'ブランチ',
  'pages.projects.app.column.image': 'コンテナイメージ',
  'pages.projects.app.column.imagePrefix': 'イメージ: {image}',
  'pages.projects.app.column.repoOrImage': 'ソース / イメージ',
  'pages.projects.app.form.description': '説明',
  'pages.projects.app.list.category.all': 'すべて',
  'pages.projects.app.list.healthRate': 'サービス正常稼働率',
  'pages.projects.app.repoMode.image': 'コンテナイメージデプロイ',
  'pages.projects.appCategory.agent': 'AI エージェント',
  'pages.projects.appCategory.backend': 'バックエンドサービス',
  'pages.projects.appCategory.frontend': 'Web フロントエンド',
  'pages.projects.appCategory.fullstack': 'フルスタックアプリ',

  'pages.projects.app.wizard.title.template': '新規アプリ / 開発環境',
  'pages.projects.app.wizard.title.config': 'アプリの設定と起動',
  'pages.projects.app.wizard.step1':
    'ステップ 1：すぐ使える開発テンプレートまたはカスタムイメージを選択',
  'pages.projects.app.wizard.step2':
    'ステップ 2：アプリのパラメータとソース方式を設定',
  'pages.projects.app.wizard.createSuccess':
    'アプリ「{name}」を作成しました。クラウドインスタンスを起動しています',
  'pages.projects.app.wizard.customImage':
    '空のアプリ / カスタムコンテナイメージから作成',
  'pages.projects.app.wizard.emptyCategory':
    '一致する開発テンプレートがありません',
  'pages.projects.app.wizard.loadFailed':
    'テンプレートの読み込みに失敗しました。再試行してください',
  'pages.projects.app.wizard.retry': '再試行',
  'pages.projects.app.wizard.search.placeholder':
    '開発テンプレート、言語、フレームワーク、技術スタックを検索...',
  'pages.projects.app.wizard.category.official': '公式スキャフォールド',
  'pages.projects.app.wizard.category.language': '言語',
  'pages.projects.app.wizard.category.framework': 'フレームワーク',
  'pages.projects.app.wizard.card.author': '提供: {author}',
  'pages.projects.app.wizard.card.use': '使用する',

  'pages.projects.app.wizard.sourceMode.createGit.title':
    'ホスト型 Git リポジトリを自動作成',
  'pages.projects.app.wizard.sourceMode.createGit.badge': '推奨 / 自動初期化',
  'pages.projects.app.wizard.sourceMode.createGit.desc':
    '内蔵 Git サービスにリポジトリを自動作成し、選択したテンプレートの雛形を投入して CI/CD パイプラインを自動連携します。',
  'pages.projects.app.wizard.sourceMode.bindGit.title':
    '既存の Git リポジトリを連携',
  'pages.projects.app.wizard.sourceMode.bindGit.badge': '外部リポジトリ',
  'pages.projects.app.wizard.sourceMode.bindGit.desc':
    '既存の GitHub / GitLab / Gitee リポジトリとブランチを連携し、Push のたびにビルドとローリングリリースを自動実行します。',
  'pages.projects.app.wizard.sourceMode.image.title':
    'コンテナイメージから直接デプロイ (Git 不要)',
  'pages.projects.app.wizard.sourceMode.image.badge': 'イメージのみ / Git 不要',
  'pages.projects.app.wizard.sourceMode.image.desc':
    'Docker イメージ（公式イメージまたはプライベートレジストリの成果物）から直接インスタンスを起動し、リポジトリの作成・連携は一切不要です。',

  'pages.projects.app.wizard.config.customImageApp':
    'カスタムコンテナイメージアプリ',
  'pages.projects.app.wizard.config.customImageDesc':
    '任意の Docker イメージを直接指定して実行し、ストレージとネットワークをマウントします',
  'pages.projects.app.wizard.config.changeTemplate': 'テンプレートを変更',
  'pages.projects.app.wizard.config.basicInfo': '基本情報',
  'pages.projects.app.wizard.config.name.required':
    'アプリ名を入力してください',
  'pages.projects.app.wizard.config.name.pattern':
    '小文字の英数字とハイフンのみ使用できます',
  'pages.projects.app.wizard.config.name.maxLength':
    '50文字以内で入力してください',
  'pages.projects.app.wizard.config.name.extra':
    'サービス名と DNS プレフィックスに使用され、作成後は変更できません',
  'pages.projects.app.wizard.config.name.placeholder': '例: my-node-service',
  'pages.projects.app.wizard.config.description.placeholder':
    'このアプリの用途と業務シーンを簡潔に説明してください',
  'pages.projects.app.wizard.config.category.required':
    'アプリの分類を選択してください',
  'pages.projects.app.wizard.config.sourceStrategy': 'ソース & ビルド戦略',
  'pages.projects.app.wizard.config.sourceStrategy.hint':
    'プラットフォームによるリポジトリ自動作成、既存 Git の連携、コンテナイメージの直接実行に対応',
  'pages.projects.app.wizard.config.repoName': 'ホスト型リポジトリ名',
  'pages.projects.app.wizard.config.repoName.extra':
    'システムが内蔵 Git サービスでこのリポジトリを自動初期化し、テンプレートの雛形と CI/CD パイプラインを投入します',
  'pages.projects.app.wizard.config.repoUrl.required':
    '既存の Git リポジトリの URL を入力してください',
  'pages.projects.app.wizard.config.branch': 'デプロイ先ブランチ',
  'pages.projects.app.wizard.config.image': 'コンテナイメージ (Image:Tag)',
  'pages.projects.app.wizard.config.image.required':
    'コンテナイメージを入力してください',
  'pages.projects.app.wizard.config.image.extra':
    '既存のコンテナイメージを直接プルしてサービスを起動します。リポジトリの作成・連携は不要です',
  'pages.projects.app.wizard.config.runtime': 'ランタイムとネットワーク設定',
  'pages.projects.app.wizard.config.cpu': 'CPU クォータ',
  'pages.projects.app.wizard.config.memory': 'メモリクォータ',
  'pages.projects.app.wizard.config.port': 'サービスポート',
  'pages.projects.app.wizard.config.port.required': 'ポートを入力してください',
  'pages.projects.app.wizard.config.publicDomain':
    'パブリックドメインルーティング',
  'pages.projects.app.wizard.config.on': 'オン',
  'pages.projects.app.wizard.config.off': 'オフ',
  'pages.projects.app.wizard.config.domainPreview':
    'パブリックドメインプレビュー：',
  'pages.projects.app.wizard.config.advanced':
    '詳細オプション (環境変数 & 起動引数)',
  'pages.projects.app.wizard.config.customCommand':
    'カスタム起動コマンド (Command & Args)',
  'pages.projects.app.wizard.config.customCommand.extra':
    '空欄の場合、テンプレートイメージのデフォルトの Entrypoint を使用します',
  'pages.projects.app.wizard.config.storage': '永続ボリュームの容量 (GB)',
  'pages.projects.app.wizard.config.storage.extra':
    'アプリの /data ディレクトリに永続マウントされます',
  'pages.projects.app.wizard.config.backToTemplate': 'テンプレート選択に戻る',
  'pages.projects.app.wizard.config.submit': '今すぐ作成して実行',
  'pages.projects.app.wizard.config.descriptionFromTemplate':
    '{name} ({version}) 開発テンプレートを使用して構築',

  // メンバー
  'pages.projects.member.column.name': '氏名',
  'pages.projects.member.column.email': 'メール',
  'pages.projects.member.column.role': 'ロール',
  'pages.projects.member.column.joinedAt': '参加日時',
  'pages.projects.member.add.title': 'メンバー追加',
  'pages.projects.member.add.success': 'メンバーを追加しました',
  'pages.projects.member.form.selectCandidate':
    '組織 / テナントメンバーから選択',
  'pages.projects.member.form.selectCandidate.placeholder':
    '氏名、ユーザー名、メールで検索して選択',
  'pages.projects.member.form.member': 'メンバー識別子 / UUID',
  'pages.projects.member.form.member.required':
    'メンバーUUIDを入力または選択してください',
  'pages.projects.member.form.member.placeholder':
    'メンバーUUIDを入力または上記から選択',
  'pages.projects.member.form.name': 'メンバー氏名',
  'pages.projects.member.form.name.placeholder':
    '例：山田 太郎（任意、IAM から自動取得）',
  'pages.projects.member.form.email': 'メンバーメール',
  'pages.projects.member.form.email.placeholder':
    '例：yamada@example.com（任意）',
  'pages.projects.member.form.role': 'プロジェクトロール',
  'pages.projects.member.role.admin': 'プロジェクト管理者',
  'pages.projects.member.role.member': 'プロジェクトメンバー',
  'pages.projects.member.remove.confirm': 'このメンバーを削除しますか？',
  'pages.projects.member.remove.success': 'メンバーを削除しました',
  'pages.projects.member.permission': 'アプリ権限管理',
  'pages.projects.permission.title': '{name} のアプリ権限マトリクス',
  'pages.projects.permission.column.app': 'アプリ名',
  'pages.projects.permission.column.visible': '表示 (Visible)',
  'pages.projects.permission.column.deploy': 'デプロイ (Deploy)',
  'pages.projects.permission.column.manage': '管理 (Manage)',
  'pages.projects.permission.save.success': '権限を保存しました',
  'pages.projects.permission.quickPreset': 'プリセット: ',
  'pages.projects.permission.presetViewer': 'すべて閲覧のみ',
  'pages.projects.permission.presetDeveloper': 'すべて開発者',
  'pages.projects.permission.presetAdmin': 'すべて管理者',

  // 監査ログ
  'pages.projects.audit.noPermission':
    '監査ログはプロジェクト管理者のみ閲覧できます',
  'pages.projects.audit.column.operator': '操作者',
  'pages.projects.audit.column.action': 'アクション',
  'pages.projects.audit.column.target': '対象',
  'pages.projects.audit.column.detail': '詳細',
  'pages.projects.audit.column.createdAt': '操作日時',
  'pages.projects.audit.action.projectCreate': 'プロジェクト作成',
  'pages.projects.audit.action.projectUpdate': 'プロジェクト更新',
  'pages.projects.audit.action.projectDelete': 'プロジェクト削除',
  'pages.projects.audit.action.appCreate': 'アプリ作成',
  'pages.projects.audit.action.appDeploy': 'デプロイ',
  'pages.projects.audit.action.appLifecycle': 'ステータス変更',
  'pages.projects.audit.action.appDelete': 'アプリ削除',
  'pages.projects.audit.action.memberAdd': 'メンバー追加',
  'pages.projects.audit.action.memberRemove': 'メンバー削除',
  'pages.projects.audit.action.memberPermissionsUpdate': '権限設定',
  'pages.projects.audit.action.databaseCreate': 'DB作成',
  'pages.projects.audit.action.databaseAction': 'DB操作',
  'pages.projects.audit.action.marketInstall':
    'マーケットテンプレートインストール',

  // デプロイ設定
  'pages.projects.deploy.title': 'デプロイ設定',
  'pages.projects.deploy.noPermission': 'デプロイ設定は管理者のみ可能です',
  'pages.projects.deploy.source': 'ソース',
  'pages.projects.deploy.source.image': 'コンテナイメージ',
  'pages.projects.deploy.source.repoBuild': 'リポジトリからビルド',
  'pages.projects.deploy.branch': 'ブランチ',
  'pages.projects.deploy.image': 'イメージURL',
  'pages.projects.deploy.resource': 'リソース構成',
  'pages.projects.deploy.cpu': 'CPU',
  'pages.projects.deploy.memory': 'メモリ',
  'pages.projects.deploy.replicas': 'レプリカ数',
  'pages.projects.deploy.network': 'ネットワーク設定',
  'pages.projects.deploy.port': 'コンテナポート',
  'pages.projects.deploy.port.exposePublic': 'パブリック公開 (Ingress)',
  'pages.projects.deploy.port.add': 'ポート追加',
  'pages.projects.deploy.envVars': '環境変数と Secret',
  'pages.projects.deploy.envVars.add': '環境変数追加',
  'pages.projects.deploy.storage': 'ストレージマウント',
  'pages.projects.deploy.storage.add': 'ストレージ追加',
  'pages.projects.deploy.healthCheck': 'ヘルスチェックプローブ',
  'pages.projects.deploy.healthCheck.enable': 'ヘルスチェック有効化',
  'pages.projects.deploy.healthCheck.path': 'プローブパス',
  'pages.projects.deploy.healthCheck.port': 'プローブポート',
  'pages.projects.deploy.submit': '保存して今すぐデプロイ',
  'pages.projects.deploy.success': 'デプロイを送信しました',

  // ライフサイクル
  'pages.projects.lifecycle.start': '起動',
  'pages.projects.lifecycle.stop': '停止',
  'pages.projects.lifecycle.stop.confirm': 'このアプリを停止しますか？',
  'pages.projects.lifecycle.restart': '再起動',
  'pages.projects.lifecycle.rollback': 'ロールバック',
  'pages.projects.lifecycle.rollback.placeholder':
    'ロールバック先バージョンを選択',
  'pages.projects.lifecycle.delete': '削除',
  'pages.projects.lifecycle.delete.confirm':
    'このアプリを削除しますか？この操作は取り消せません',
  'pages.projects.lifecycle.success': '操作を受け付けました',

  // 設定とクォータ
  'pages.projects.settings.basicInfo': '基本情報',
  'pages.projects.settings.saveChanges': '変更を保存',
  'pages.projects.settings.saveSuccess': 'プロジェクト基本情報を更新しました',
  'pages.projects.settings.quotaSuccess':
    'クォータ拡張申請を提出しました（CPU: {cpu} Core, メモリ: {memory} GiB）',
  'pages.projects.settings.field.uuid': 'プロジェクト識別子 (UUID / Namespace)',
  'pages.projects.settings.quotaManagement': '計算リソース＆クォータ管理',
  'pages.projects.settings.applyQuota': 'クォータ拡張を申請',
  'pages.projects.settings.quotaProtectionTitle': 'クォータ保護機能が有効です',
  'pages.projects.settings.quotaProtectionDesc':
    'プロジェクト内の全アプリの合計リソースが上限に達すると、ノードのOOMを防ぐため新規デプロイが安全に制限されます。',
  'pages.projects.settings.cpuLimit': 'CPU 上限 (Core)',
  'pages.projects.settings.allocatedUsage': '割当済み: {used} Core',
  'pages.projects.settings.memoryLimit': 'メモリ容量上限 (GiB)',
  'pages.projects.settings.allocatedUsageGiB': '割当済み: {used} GiB',
  'pages.projects.settings.storageLimit': '永続ストレージ上限 (GiB)',
  'pages.projects.settings.mountedPvc': 'マウント済み PVC: {used} GiB',
  'pages.projects.settings.dangerZone':
    'プロジェクトライフサイクル管理（危険ゾーン）',
  'pages.projects.settings.archive.title': 'プロジェクトをアーカイブ',
  'pages.projects.settings.archive.hint':
    '稼働中の全インスタンスを凍結し、計算コストを停止します。データは保持されます',
  'pages.projects.settings.archive.button': 'アーカイブ',
  'pages.projects.settings.archive.confirm':
    'プロジェクトをアーカイブしますか？',
  'pages.projects.settings.archive.content':
    'アーカイブ後、全アプリが凍結状態となり、設定とPVデータはそのまま保持されます。',
  'pages.projects.settings.archive.ok': 'アーカイブ実行',
  'pages.projects.settings.archive.success':
    'プロジェクト「{name}」をアーカイブしました',
  'pages.projects.settings.destroy.title': 'プロジェクトを完全削除',
  'pages.projects.settings.destroy.hint':
    'Kubernetes Namespace、全コンテナおよびストレージボリュームを直ちに削除します。復元不可。',
  'pages.projects.settings.destroy.button': '完全削除',
  'pages.projects.settings.destroy.confirm':
    '危険な操作：プロジェクトを完全削除しますか？',
  'pages.projects.settings.destroy.content':
    'この操作は取り消せません！すべてのPod、PVC、および権限設定が破棄されます。',
  'pages.projects.settings.destroy.ok': '強制削除',
  'pages.projects.settings.destroy.success':
    'プロジェクト「{name}」を削除しました',
  'pages.projects.settings.expandModal.title': 'クォータ拡張の申請',
  'pages.projects.settings.expandModal.ok': '申請',
  'pages.projects.settings.expandModal.cpu': '目標 CPU 上限 (Core)',
  'pages.projects.settings.expandModal.memory': '目標メモリ上限 (GiB)',
  'pages.projects.settings.expandModal.storage': '目標ストレージ上限 (GiB)',

  // プラットフォーム管理（プレースホルダー）
  'pages.management.placeholder.fields': '計画中の機能 / 項目：',
  'pages.management.identities.description':
    '企業内の全稼働主体（人間社員、外部関係者、Agent、デジタルワーカー、システムアカウント）を一元管理するアイデンティティリポジトリです。プロジェクトメンバーはここから選択されます。',
  'pages.management.identityType.human': '従業員',
  'pages.management.identityType.external': '外部関係者',
  'pages.management.identityType.agent': 'Agent',
  'pages.management.identityType.digital': 'デジタルワーカー',
  'pages.management.identityType.system': 'システムアカウント',
  'pages.management.roles.description':
    'プロジェクトに依存しないグローバルロールおよび権限マトリクス。アプリ/データ/API/Agent の4次元でアクセス範囲を定義します。',
  'pages.management.role.globalAdmin': 'グローバル管理者',
  'pages.management.role.workspaceOwner': 'ワークスペースオーナー',
  'pages.management.role.developer': '開発者',
  'pages.management.role.viewer': '閲覧者',
  'pages.management.role.agentCaller': 'Agent 呼出担当',
  'pages.management.auditLog.description':
    'プロジェクト横断のプラットフォーム監査ログ。プロジェクト別に絞り込み可能で、監査権限を持つロールにのみ公開されます。',
  'pages.management.auditLog.field.operator': '操作者',
  'pages.management.auditLog.field.project': '対象プロジェクト',
  'pages.management.auditLog.field.action': 'アクション',
  'pages.management.auditLog.field.result': '結果',
  'pages.management.auditLog.field.time': '日時',
  'pages.management.clusters.description':
    'グローバル管理者向けの Kubernetes クラスタおよびインフラ運用エントリ。ノード、リソース、ヘルスチェック、アラートなどを網羅します。',
  'pages.management.clusters.field.nodes': 'ノード管理',
  'pages.management.clusters.field.resource': 'リソース監視',
  'pages.management.clusters.field.health': 'ヘルスチェック',
  'pages.management.clusters.field.alerts': 'アラート',
  'pages.auditLog.title': 'パノラマセキュリティ・AI監査ダッシュボード',
  'pages.auditLog.description':
    'プラットフォームのライフサイクル全体における重要なシステム操作、機密データアクセス、AI AgentのLLM呼び出しとToken消費を集中記録し、エンタープライズのコンプライアンスと追跡性を満たします。',
  'pages.auditLog.action.refresh': '更新',
  'pages.auditLog.stats.totalOperations': '本日の全体操作',
  'pages.auditLog.stats.sensitiveOperations': '機密・高リスク操作',
  'pages.auditLog.stats.aiCalls': 'AI Agent リアルタイム呼出',
  'pages.auditLog.stats.totalTokens': '本日のToken総消費量',
  'pages.auditLog.stats.timesSuffix': '回',
  'pages.auditLog.stats.tenThousand': '万',
  'pages.auditLog.filter.all': 'すべての監査',
  'pages.auditLog.filter.operation': 'システム操作監査',
  'pages.auditLog.filter.aiCall': 'AI Token 監査',
  'pages.auditLog.filter.dataAccess': 'データアクセス追跡',
  'pages.auditLog.filter.keywordPlaceholder':
    '操作者/Agent/アクション/ターゲットを検索...',
  'pages.auditLog.filter.search': '検索',
  'pages.auditLog.filter.startDate': '開始日時',
  'pages.auditLog.filter.endDate': '終了日時',
  'pages.auditLog.table.operator': '操作主体',
  'pages.auditLog.table.type': '監査タイプ',
  'pages.auditLog.table.actionTarget': 'アクションとターゲット',
  'pages.auditLog.table.project': '所属プロジェクト',
  'pages.auditLog.table.metrics': 'AI / パフォーマンス指標',
  'pages.auditLog.table.status': 'ステータス',
  'pages.auditLog.table.time': '操作日時',
  'pages.auditLog.table.detail': '詳細',
  'pages.auditLog.table.totalCount': '合計 {total} 件',
  'pages.auditLog.badge.operation': 'システム操作',
  'pages.auditLog.badge.aiCall': 'AI Token 監査',
  'pages.auditLog.badge.dataAccess': 'データアクセス',
  'pages.auditLog.status.success': '成功',
  'pages.auditLog.status.warning': '警告',
  'pages.auditLog.status.failed': '失敗',
  'pages.auditLog.operatorType.agent': 'エージェント',
  'pages.auditLog.operatorType.system': 'システム',
  'pages.auditLog.operatorType.human': 'ユーザー',
  'pages.auditLog.drawer.title': '監査ログ追跡詳細',
  'pages.auditLog.drawer.basicContext': '基本コンテキスト',
  'pages.auditLog.drawer.id': '監査 ID:',
  'pages.auditLog.drawer.operator': '操作主体:',
  'pages.auditLog.drawer.project': '所属プロジェクト:',
  'pages.auditLog.drawer.platformGlobal': 'プラットフォーム全体',
  'pages.auditLog.drawer.clientIp': 'クライアント IP:',
  'pages.auditLog.drawer.occurredAt': '発生日時:',
  'pages.auditLog.drawer.actionDetail': '操作および詳細説明',
  'pages.auditLog.drawer.action': 'アクション名:',
  'pages.auditLog.drawer.target': '影響対象:',
  'pages.auditLog.drawer.detail': '実行詳細:',
  'pages.auditLog.drawer.aiDetail': 'AI Runtime スケジューリング詳細',
  'pages.auditLog.drawer.model': 'ベースLLM:',
  'pages.auditLog.drawer.promptTokens': 'Prompt Tokens:',
  'pages.auditLog.drawer.completionTokens': 'Completion Tokens:',
  'pages.auditLog.drawer.totalTokens': '合計 Token:',
  'pages.auditLog.drawer.latency': 'レイテンシ:',
  'pages.auditLog.metric.prompt': 'Prompt',
  'pages.auditLog.metric.completion': 'Completion',
  'pages.auditLog.metric.latency': '所要時間',
  'pages.auditLog.metric.ip': 'IP',
  'pages.platformTenants.title': 'テナント管理',
  'pages.platformUsers.title': 'ユーザー管理',
  'pages.platformUsers.resetPassword': 'パスワードをリセット',
  'pages.platformUsers.resetPasswordTitle': '「{name}」のパスワードをリセット',
  'pages.platformUsers.resetPasswordNotice':
    'リセット後、旧パスワードはすぐに無効になります。新しいパスワードは安全な方法でユーザーに伝えてください。',
  'pages.platformUsers.newPassword': '新しいパスワード',
  'pages.platformUsers.newPasswordRequired':
    '新しいパスワードを入力してください',
  'pages.platformUsers.newPasswordLength': 'パスワードは 6〜64 文字です',
  'pages.platformUsers.generatePassword': '自動生成',
  'pages.platformUsers.copyPassword': 'パスワードをコピー',
  'pages.platformUsers.passwordCopied': 'クリップボードにコピーしました',
  'pages.platformUsers.passwordCopyFailed':
    'コピーに失敗しました。手動でコピーしてください',
  'pages.platformUsers.resetPasswordSuccess': 'パスワードをリセットしました',
  'pages.platformUsers.avatar': 'アバター',
  'pages.platformUsers.avatarUpload': 'アバターをアップロード',
  'pages.platformUsers.avatarHint': 'PNG・JPG・WEBP、5MB 以下',
  'pages.platformUsers.uploadFailed':
    'アップロードに失敗しました。もう一度お試しください',
  'pages.platformUsers.save': '保存',
  'pages.platformUsers.reset': 'リセット',
  'pages.platformUsers.saveSuccess': 'プロフィールを保存しました',
  'pages.platformUsers.website': 'ウェブサイト',
  'pages.platformUsers.websiteInvalid': '有効な URL を入力してください',
  'pages.platformUsers.country': '国',
  'pages.platformUsers.province': '都道府県',
  'pages.platformUsers.city': '市区町村',
  'pages.platformUsers.postalCode': '郵便番号',
  'pages.platformUsers.identifierClearForbidden':
    'このユーザーにはユーザー名がないため、電話番号とメールを両方空にするとログインできなくなります',
  'pages.platformUsers.usernameImmutableHint':
    'ユーザー名は作成後に変更できません',
  'pages.platformUsers.tab.basic': '基本情報',
  'pages.platformUsers.tab.tenants': '所属テナント',
  'pages.platformUsers.tab.identities': '外部アカウント',
  'pages.platformUsers.tab.loginHistory': 'ログイン履歴',
  'pages.platformUsers.userNotFound':
    'ユーザーが存在しないか、削除されています',
  'pages.platformUsers.sectionAccount': 'アカウント',
  'pages.platformUsers.sectionProfile': 'プロフィール',
  'pages.platformUsers.verified': '確認済み',
  'pages.platformUsers.unverified': '未確認',
  'pages.platformUsers.registerSourceLabel': '登録方法',
  'pages.platformUsers.registerSource.adminCreated': '管理者が作成',
  'pages.platformUsers.registerSource.basic:phone': '電話番号',
  'pages.platformUsers.registerSource.basic:email': 'メール',
  'pages.platformUsers.registerSource.basic:username': 'ユーザー名',
  'pages.platformUsers.signedUp': '登録日時',
  'pages.platformUsers.validity': 'アカウント有効期限',
  'pages.platformUsers.perpetual': '無期限',
  'pages.platformUsers.loginsCount': 'ログイン回数',
  'pages.platformUsers.lastLogin': '最終ログイン日時',
  'pages.platformUsers.lastIp': '最終ログイン IP',
  'pages.platformUsers.genderLabel': '性別',
  'pages.platformUsers.gender.M': '男性',
  'pages.platformUsers.gender.F': '女性',
  'pages.platformUsers.gender.U': '不明',
  'pages.platformUsers.birthdate': '誕生日',
  'pages.platformUsers.company': '会社',
  'pages.platformUsers.address': '番地・建物名',
  'pages.platformUsers.tenantName': 'テナント名',
  'pages.platformUsers.tenantCode': 'テナントコード',
  'pages.platformUsers.departments': '所属部署',
  'pages.platformUsers.departmentPath': '部署パス',
  'pages.platformUsers.noDepartments': 'どの部署にも所属していません',
  'pages.platformUsers.noIdentities': '連携済みの外部アカウントはありません',
  'pages.platformUsers.idpName': 'ID プロバイダー',
  'pages.platformUsers.idpCategory': '種別',
  'pages.platformUsers.idpCategory.enterprise': '企業',
  'pages.platformUsers.idpCategory.social': 'ソーシャル',
  'pages.platformUsers.idpDisplayName': 'アカウント名',
  'pages.platformUsers.idpUserId': 'プロバイダー側ユーザー ID',
  'pages.platformUsers.bindTime': '連携日時',
  'pages.platformUsers.noLoginHistory': 'ログイン記録はありません',
  'pages.platformUsers.loginTime': '日時',
  'pages.platformUsers.loginApp': 'アプリ',
  'pages.platformUsers.loginEvent': 'イベント',
  'pages.platformUsers.loginResult': '結果',
  'pages.platformUsers.loginIp': 'IP アドレス',
  'pages.platformUsers.loginLocation': '場所',
  'pages.platformUsers.loginClient': 'ブラウザ / OS / デバイス',
  'pages.platformUsers.keywordLabel': 'キーワード',
  'pages.platformUsers.searchPlaceholder':
    'ユーザー名・氏名・電話番号・メールで検索',
  'pages.platformUsers.user': 'ユーザー',
  'pages.platformUsers.userId': 'ユーザー ID',
  'pages.platformUsers.username': 'ユーザー名',
  'pages.platformUsers.name': '氏名',
  'pages.platformUsers.namePlaceholder': '氏名',
  'pages.platformUsers.nickname': 'ニックネーム',
  'pages.platformUsers.phone': '電話番号',
  'pages.platformUsers.email': 'メール',
  'pages.platformUsers.password': '初期パスワード',
  'pages.platformUsers.statusLabel': 'ステータス',
  'pages.platformUsers.status.Activated': '有効',
  'pages.platformUsers.status.Suspended': '停止中',
  'pages.platformUsers.status.Deleted': '削除済み',
  'pages.platformUsers.createdAt': '作成日時',
  'pages.platformUsers.updatedAt': '更新日時',
  'pages.platformUsers.actions': '操作',
  'pages.platformUsers.edit': '編集',
  'pages.platformUsers.enable': '有効化',
  'pages.platformUsers.disable': '停止',
  'pages.platformUsers.delete': '削除',
  'pages.platformUsers.createUser': 'ユーザーを作成',
  'pages.platformUsers.detailTitle': 'ユーザー詳細',
  'pages.platformUsers.tenants': '所属テナント',
  'pages.platformUsers.noTenants': 'どのテナントにも所属していません',
  'pages.platformUsers.usernamePlaceholder': 'パスワードログインに使用',
  'pages.platformUsers.phonePlaceholder': '認証コードログインに使用',
  'pages.platformUsers.emailPlaceholder': 'name@example.com',
  'pages.platformUsers.passwordHint':
    '任意。後から認証コードでログインするか、パスワードをリセットできます。',
  'pages.platformUsers.emailInvalid': 'メールアドレスの形式が正しくありません',
  'pages.platformUsers.identifierRequired':
    'ユーザー名・電話番号・メールのいずれかを入力してください',
  'pages.platformUsers.createSuccess': 'ユーザーを作成しました',
  'pages.platformUsers.enableSuccess': '有効化しました',
  'pages.platformUsers.disableSuccess': '停止しました',
  'pages.platformUsers.deleteSuccess': 'ユーザーを削除しました',
  'pages.platformUsers.enableConfirm': 'このユーザーを有効化しますか？',
  'pages.platformUsers.disableConfirm':
    '停止すると、どのテナントにもログインできなくなります。停止しますか？',
  'pages.platformUsers.batchEnable': '一括有効化',
  'pages.platformUsers.batchDisable': '一括停止',
  'pages.platformUsers.clearSelection': '選択解除',
  'pages.platformUsers.batchEnableConfirm':
    '選択した {count} 名のユーザーを有効化しますか？',
  'pages.platformUsers.batchDisableConfirm':
    '選択した {count} 名のユーザーはログインできなくなります。停止しますか？',
  'pages.platformUsers.deleteConfirmTitle':
    'ユーザー「{name}」を削除しますか？',
  'pages.platformUsers.deleteConfirmContent':
    'アカウントはユーザープールから削除され、すべてのテナントのメンバー資格を失います。元に戻せません。',
  'pages.platformTenants.searchPlaceholder': 'テナント名またはUUIDを検索',
  'pages.platformTenants.keywordLabel': 'キーワード',
  'pages.platformTenants.name': 'テナント名',
  'pages.platformTenants.uuid': 'テナントUUID',
  'pages.platformTenants.code': 'テナントコード',
  'pages.platformTenants.memberCount': 'メンバー数',
  'pages.platformTenants.createdAt': '作成日時',
  'pages.platformTenants.actions': '操作',
  'pages.platformTenants.viewDetail': '詳細を見る',
  'pages.platformTenants.backToList': 'テナント一覧に戻る',
  'pages.platformTenants.tabMembers': 'メンバー',
  'pages.platformTenants.tabDepartments': '組織',
  'pages.platformTenants.keywordSearch': '氏名、電話、メール、社員番号を検索',
  'pages.platformTenants.memberName': '氏名',
  'pages.platformTenants.memberPhone': '電話番号',
  'pages.platformTenants.memberEmail': 'メールアドレス',
  'pages.platformTenants.memberJobNumber': '社員番号',
  'pages.platformTenants.memberPosition': '役職',
  'pages.platformTenants.memberStatus': 'ステータス',
  'pages.platformTenants.statusEnabled': '有効',
  'pages.platformTenants.statusDisabled': '無効',
  'pages.platformTenants.memberRole': 'ロール',
  'pages.platformTenants.admin': '管理者',
  'pages.platformTenants.regularMember': '一般メンバー',
  'pages.platformTenants.leader': '部門責任者',
  'pages.platformTenants.drawerTitle': 'メンバー詳細プロファイル',
  'pages.platformTenants.joinedAt': '参加日時',
  'pages.platformTenants.username': 'ユーザー名',
  'pages.platformTenants.department': '所属部署',
  'pages.platformTenants.includeChildren': 'サブ部門を含める',
  'pages.platformTenants.selectDepartmentPrompt':
    '左側の部署を選択してください',
  'pages.platformTenants.noDepartments': '部署データがありません',
  'pages.platformTenants.totalCount': '合計 {total} 件',
  'pages.platformTenants.tabApps': 'アプリ',
  'pages.platformTenants.description': '説明',
  'pages.platformTenants.logo': 'ロゴ',
  'pages.platformTenants.logoUpload': 'ロゴをアップロード',
  'pages.platformTenants.logoHint': 'png/jpg/svg/webp、5MB 以下',
  'pages.platformTenants.nameRequired': 'テナント名を入力してください',
  'pages.platformTenants.saveSuccess': 'テナント情報を更新しました',
  'pages.platformTenants.saveFailed':
    '保存に失敗しました。しばらくしてから再試行してください',
  'pages.platformTenants.uploadFailed': 'ロゴのアップロードに失敗しました',
  'pages.platformTenants.appName': 'アプリ名',
  'pages.platformTenants.appId': 'アプリ ID',
  'pages.platformTenants.installSource': '開通元',
  'pages.platformTenants.installSourcePackage': 'プラン',
  'pages.platformTenants.installSourceTenant': '個別開通',
  'pages.platformTenants.noApps': 'このテナントはまだアプリを開通していません',
  'pages.platformTenants.appsLoadFailed': 'アプリ一覧の読み込みに失敗しました',
  'pages.platformTenants.tabBasic': '基本情報',
  'pages.platformTenants.save': '保存',
  'pages.platformTenants.reset': 'リセット',
  'pages.platformTenants.updatedAt': '更新日時',
  'pages.platformTenants.profileCard': '基本プロフィール',
  'pages.platformTenants.infoCard': 'テナント情報',
  'pages.myTenants.title': 'テナント設定',
  'pages.myTenants.member': 'メンバー',
  'pages.myTenants.empty': 'まだどの企業にも参加していません',
  'pages.myTenants.selectTenant':
    '現在のテナントを特定できません。再度サインインしてください',
  'pages.platformTenants.loadCommercialConfigFailed':
    '商用設定の読み込みに失敗しました',
  'pages.platformTenants.loadCommercialStatusFailed':
    'テナントの商用ステータスの読み込みに失敗しました',
  'pages.platformTenants.grantSuccess': '付与が有効になりました',
  'pages.platformTenants.grantFailed': '付与に失敗しました',
  'pages.platformTenants.subscriptionType': '種類',
  'pages.platformTenants.status': 'ステータス',
  'pages.platformTenants.target': '対象',
  'pages.platformTenants.adminGift': '管理者付与',
  'pages.platformTenants.startsAt': '開始日時',
  'pages.platformTenants.expiresAt': '有効期限',
  'pages.platformTenants.perpetual': '無期限',
  'pages.platformTenants.purchaseParams': '購入内容',
  'pages.platformTenants.orderNo': '注文番号',
  'pages.platformTenants.orderDefaultPlan': 'システム標準',
  'pages.platformTenants.orderMarketFree': 'マーケット無料',
  'pages.platformTenants.appsCount': '{count} 件のアプリ',
  'pages.platformTenants.featureCode': '権益コード',
  'pages.platformTenants.featureName': '権益名',
  'pages.platformTenants.featureType': '種類',
  'pages.platformTenants.finalValue': '最終値',
  'pages.platformTenants.sources': '付与元',
  'pages.platformTenants.tenantCommercialStatus': 'テナントの商用ステータス',
  'pages.platformTenants.adminGrant': '管理者付与',
  'pages.platformTenants.entitlementIntro':
    'テナントの最終的な商用権益です。業務システムはプラン名ではなく権益コードで認可してください。',
  'pages.platformTenants.subscriptions': 'サブスクリプション',
  'pages.platformTenants.finalEntitlements': '最終権益',
  'pages.platformTenants.tabEntitlements': '権益',
  'pages.platformTenants.tabRoles': 'ロール',
  'pages.platformTenants.tabAudit': '監査ログ',
  'pages.platformTenants.detailTitle': 'テナント詳細',
  'pages.platformTenants.typePlan': 'プラン契約',
  'pages.platformTenants.typeAddon': '追加購入',
  'pages.platformTenants.typeManualGrant': '手動付与',
  'pages.platformTenants.on': 'オン',
  'pages.platformTenants.off': 'オフ',
  'pages.platformTenants.seatsUnit': '{count} 席',
  'pages.platformTenants.quantityUnit': '{count} 個',
  'pages.platformTenants.monthsUnit': '{count} か月',
  'pages.platformTenants.amountYuan': '{amount} 元',
  'pages.platformTenants.refresh': '更新',
  'pages.platformTenants.grantType': '付与の種類',
  'pages.platformTenants.planVersion': 'プランバージョン',
  'pages.platformTenants.priceItem': '価格項目',
  'pages.platformTenants.addonProduct': '追加購入商品',
  'pages.platformTenants.purchaseQuantity': '購入数量',
  'pages.platformTenants.targetFeature': '対象の権益',
  'pages.platformTenants.switchState': 'オン/オフ',
  'pages.platformTenants.numericValue': '数値',
  'pages.platformTenants.applicationCodes': 'アプリコード一覧（1 行に 1 つ）',
  'pages.platformTenants.seatCount': '席数',
  'pages.platformTenants.months': '契約月数',
  'pages.platformTenants.paidAmount': '支払金額（元）',
  'pages.myTenants.detailTitle': 'テナント設定',
};
